export default "__VITE_ASSET__B$m3VAMt__"